/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';

import { FETCH_SD_ONLINE_CATEGORIES } from './actionTypes';

import { fetchSdOnlineCategoriesUtil } from './utils';

/**
 * Contains the action creator functions that update the OnlineCategories slice of the store.
 *
 * @namespace OnlineCategoriesActions
 */
export default class actions {
  /**
   * Calls the api and dispatches the results to the store.
   * api: /v1/ua/sd_online_categories
   *
   * @param {any} callback function to call once this function has finished
   * @function
   * @memberof OnlineCategoriesActions
   */
  static fetchSdOnlineCategories = (dispatch, callback) => {
    ReduxUtils.generateAction(
      dispatch,
      fetchSdOnlineCategoriesUtil,
      FETCH_SD_ONLINE_CATEGORIES,
      callback
    );
  };

  /**
   * Dispatches the data to the store to reset the data cached from a call to fetchSdOnlineCategories.
   *
   * @param {function} dispatch
   * @param {Object} data object to be set in the store.
   * @function
   * @memberof OnlineCategoriesActions
   */
  static resetFetchSdOnlineCategories = (dispatch, data) => {
    const json = {
      type: FETCH_SD_ONLINE_CATEGORIES.successAction,
      payload: data,
    };
    dispatch(json);
  };

  /**
   * Dispatches the data to the store to reset the error cached from a call to fetchSdOnlineCategories.
   *
   * @param {function} dispatch
   * @function
   * @memberof OnlineCategoriesActions
   */
  static resetFetchSdOnlineCategoriesError = dispatch => {
    ReduxUtils.resetErrorAction(dispatch, FETCH_SD_ONLINE_CATEGORIES.failureAction);
  };
}
